import React, {Fragment} from 'react';
import {AutoComplete, Button, Card, Form, Input, Modal, notification, Select, Space, Typography} from "antd";

import ApiService from "../../services/ApiService"
import IntlMessage from "../../components/util-components/IntlMessage";
import {getContactAdresses, getContactEmails} from "./functions";
import {t} from "@lingui/core/macro"
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {Trans} from "@lingui/react/macro";
import StaredField from "../../components/custom-fields/Stared";
import {uuid} from "short-uuid";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalEditEmails extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        contactId: null,
        id: null,
        edit: false,
        adresses: [],
        defaultData: {}

    };

    state = this.initialState;

    async show(contact={}) {
        console.log(contact)
        if (contact.id)
        {
            const emails=getContactEmails(contact)
            const adresses=getContactAdresses(contact)
            const mainIndex=emails.findIndex(i=>i.main) || 0

            console.log("mainIndex",mainIndex)

            this.setState({
                visible: true,
                edit: true,
                adresses: adresses,
                contact: contact,
                id: contact.id,
                mainIndex: mainIndex,
                defaultData: {emails:emails}
            })
        } else {
            //this.setState({visible: true, adresses: adresses, contactId: contactId})
        }
    }

    close() {
        this.setState(this.initialState)
    }


    getFinalData(data)
    {

        let object={
            email:null,
            emailLabel:null,
            emailAdresseId:null,

            emails:[],
        }

        let i=0
        for(let t of data.emails)
        {
            const item={
                type:t.type,
                email:t.email,
                adresseId:t.adresseId,
            }

            if(this.state.mainIndex===i){
                object.emailLabel=item.type
                object.email=item.email
                object.emailAdresseId=item.adresseId

            }else{
                item.id=t.id || uuid()
                object.emails.push(item)
            }

            i++
        }

        return object
    }


    async onSubmit(data) {

        const finalData=this.getFinalData(data)
        console.log(data,finalData)

        //return false

        this.setState({loading: true})

        var res = await ApiService.post("/contact/edit/partial/" + this.state.id, finalData)
        console.log(res)

        if (res.success) {
            if (res.message) {
                notification.warn({
                    message: res.message
                })
            } else {
                notification.success({
                    message: this.state.edit ? (<IntlMessage id="success.edit"/>) : (<IntlMessage id="success.add"/>)
                })
            }

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(res.data)
            }
        } else {
            notification.success({
                message: this.state.edit ? (<IntlMessage id="error.edit"/>) : (<IntlMessage id="error.add"/>)
            })
        }

        this.setState({loading: false})
    }

    render()
    {

        return (
            <Modal width="100%" title={<span>{this.state.id ? <Trans>Editer</Trans> : <Trans>Ajouter</Trans>} <Trans>les emails</Trans></span>}
                   open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>

                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                    initialValues={this.state.defaultData}
                >

                    <Form.List name="emails">
                        {(fields, {add, remove}) => (
                            <Space direction={"vertical"} size={"large"} style={{width:"100%"}}>

                            {fields.map(({key, name, ...restField}) => (
                                <Form.Item noStyle shouldUpdate>
                                    {(_form)=> {
                                        const title=_form.getFieldValue(["emails",name,"type"])
                                        //console.log("title",title)

                                        return (
                                            <Card title={title} key={key} type={"inner"} extra={(
                                                <Space>
                                                    <StaredField value={(this.state.mainIndex || 0)==name} onChange={(v)=>this.setState({mainIndex:name})}/>
                                                    <MinusCircleOutlined color={"red"} onClick={() => remove(name)}/>
                                                </Space>
                                            )}>
                                                <Form.Item
                                                    label={<Trans>Type d'email</Trans>}
                                                    name={[name,"type"]}
                                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                >
                                                    <AutoComplete
                                                        options={[t`Domicile`, t`Societe`, t`Bureau`, t`Autre`].map(i => ({value: i}))}
                                                        filterOption={(inputValue, option) =>
                                                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                        }>
                                                        <Input placeholder={t`Type de d'email`}/>
                                                    </AutoComplete>
                                                </Form.Item>


                                                <Form.Item
                                                    label={<Trans>Email</Trans>}
                                                    name={[name,"email"]}
                                                    rules={[{required: true, message: 'Ce champ est obligatoire'}]}
                                                >
                                                    <Input placeholder={t`Email`} />
                                                </Form.Item>


                                                {this.state.adresses.length > 0 && (
                                                    <Form.Item
                                                        label={<Trans>Adresse</Trans>}
                                                        name={[name,"adresseId"]}
                                                    >
                                                        <Select style={{width: "100%"}} placeholder={t`Lier avec une Adresse`}>
                                                            {this.state.adresses.map(i => {
                                                                return (
                                                                    <Select.Option value={i.id}>
                                                                        {i.siren && (
                                                                            <Fragment>
                                                                                <Trans>Société</Trans>: {i.nom} ({i.siren})
                                                                                - {i.adresse}, {i.postal}, {i.ville}, {i.pays}
                                                                            </Fragment>
                                                                        )}

                                                                        {!i.siren && (
                                                                            <Fragment>
                                                                                {i.nom} - {i.adresse}, {i.postal}, {i.ville}, {i.pays}
                                                                            </Fragment>
                                                                        )}
                                                                    </Select.Option>
                                                                )
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                )}
                                            </Card>
                                        )
                                    }}
                                </Form.Item>
                                ))}


                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} block
                                            icon={<PlusOutlined/>}>
                                        <Trans>Ajouter un Email</Trans>
                                    </Button>
                                </Form.Item>
                            </Space>
                        )}
                    </Form.List>




                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>

            </Modal>
        )
    }
}
